/**
 * @ngdoc service
 * @name common.service:ShopCartPackagingErrorService
 *
 * @description
 * A service that manage the shop cart indom 120 error packaging logic.
 *
 */
(function () {
    'use strict';

    angular.module('itxApp.common').service('ShopCartPackagingErrorService', ShopCartPackagingErrorService);

    ShopCartPackagingErrorService.$inject = ['$q', 'ngDialog'];

    function ShopCartPackagingErrorService($q, ngDialog) {
        var _this = this;
        _this.dialogOpen = false;

        var service = {
            openModalGiftError: openModalGiftError,
            deleteOnlyGiftPacking: deleteOnlyGiftPacking
        };

        return service;

        /**
         * @ngdoc method
         * @name openModalGiftError
         * @methodOf
         * @description
         * Open Modal gift error.
         */
        function openModalGiftError(shopCart) {
            if (!_this.dialogOpen) {
                _this.dialogOpen = true;
                var dialog = ngDialog.open({
                    template: '<itx-shop-cart-packaging-error shop-cart="ngDialogData.shopCart"></itx-shop-cart-packaging-error>',
                    className: 'new-modal ma-modal-md ma-modal-macro ngdialog-theme-plain ngdialog-gift-ticket',
                    plain: true,
                    showClose: true,
                    data: {
                        shopCart: shopCart
                    }
                });
                dialog.closePromise.then(function () {
                    _this.dialogOpen = false;
                });
            }
        }

        /**
         * @ngdoc method
         * @name deleteGiftPacking
         * @methodOf common.service:ShopCartPackagingErrorService
         * Delete the gift packing from an order.
         */
        function deleteOnlyGiftPacking() {
            var deferred = $q.defer();

            var action = {
                action: 'order:deleteGiftPacking',
                params: {
                    storeId: inditex.iStoreId,
                    orderId: inditex.iUserJSON.shopCart.id,
                    languageId: inditex.iLangId,
                    onlyGiftPacking: true
                }
            };
            joyr.rest
                .xRestExecute([action])
                .done(function () {
                    if (deleteAll) {
                        deferred.resolve(setGiftTicket(false));
                    } else {
                        deferred.resolve();
                    }
                })
                .Catch(function () {
                    deferred.reject();
                });

            return deferred.promise;
        }
    }
})();
